import { Input, TemplateRef, ChangeDetectionStrategy, ViewEncapsulation, ComponentFactoryResolver, ViewContainerRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TableViewConfig, PagerInfo, TableField } from './table-config';

import { _HttpClient } from '../../net/http.client';
import { TableRenderService } from './table-render.service';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Renderer2 } from '@angular/core';
import { ElementRef } from '@angular/core';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';


@Component({
  selector: 'app-table-view',
  templateUrl: './app-table.component.html',
  styleUrls: ['./app-table.component.less'],
  providers: [TableRenderService]
})

export class AppTableComponent implements OnInit {


  public _config: TableViewConfig;
  @Input() set config(value: TableViewConfig) {
    this._config = value;
    this._config.setHttpClient(this.http);

    // this._config._change = this.cdr;
    if (!value) {
      throw new Error("No initialization configuration RootConfig.");
    }
    if (!value.dataSource) {
      throw new Error("dataSource is null");
    }
  };

  constructor(private cdr: ChangeDetectorRef, public http: _HttpClient, public renderService: TableRenderService, private renderer2: Renderer2, private el: ElementRef) {

  }

  ngOnInit() {
    fromEvent(window, 'resize')
      .pipe(debounceTime(100))
      .subscribe(() => this.setLayout());

     this._config.listeners.onUpdateView = () => this.setLayout();
  }


  setLayout() {
    if (document.documentElement.clientWidth < 800) {
      this._config.y_Scroll = 300;
      this.cdr.detectChanges();
    }
    var body = this.el.nativeElement.querySelector('.ant-table-body');
    if (body == null) {
      return;
    }
    var top = body.getBoundingClientRect().top;
    body.style.maxHeight = document.body.clientHeight - top - 100 + "px";
  }
  onAllChecked(value: boolean): void {
    // this._config.dataSource.forEach(item => item.selectstate = value);
    // this._config.refreshCheckedStatus();

    this._config.dataSource.forEach(item => {
      if (!item.Disable) {
        item.selectstate = value;
      }
    });
    this._config.refreshCheckedStatus();
  }


  onItemChecked(data: any, checked: boolean): void {
    data.selectstate = checked;
    this._config.refreshCheckedStatus();

  }

  onQueryParamsChange(params: NzTableQueryParams): void {

    const { pageSize, pageIndex, sort, filter } = params;
    const currentSort = sort.find(item => item.value);
    const sortField = (currentSort && currentSort.key) || null;
    const sortOrder = (currentSort && currentSort.value) || null;
    this.Search(pageIndex, pageSize, sortField, sortOrder, filter);
  }

  Search(
    pageIndex: number,
    pageSize: number,
    sortField: string | null,
    sortOrder: string | null,
    filter: Array<{ key: string; value: string[] }>
  ): void {
    this._config.pagerInfo.pageIndex = pageIndex;
    this._config.pagerInfo.pageSize = pageSize;
    if (sortField) {
      this._config.params.sortInfo.sortField = sortField;
    }
    if (sortOrder) {
      this._config.params.sortInfo.sortOrder = sortOrder;
    }

    this._config.reload();
  }

  columeSearch(colum) {
    this._config.params.queryJson[colum.dataIndex] = colum.searchValue;
    colum.searchVisible = false;
    this._config.reload();
  }

  resetColumeSearch(colum) {
    this._config.params.queryJson[colum.dataIndex] = null;
    colum.searchValue = "";
    colum.searchVisible = false;
    this._config.reload();
  }

  filterChange(item, e) {
    item.searchValue = e;
    this._config.params.queryJson[item.dataIndex] = e;
  }

  onResize({ width }: NzResizeEvent, item): void {
    item.width = width + 'px';
  }
  onCellClick(item, cell) {
    if (this._config.listeners && this._config.listeners.onCellClick)
      this._config.listeners.onCellClick(item, cell);

  }
  onRowClick(item) {
    if (!this._config.checkBox) {
      this.onAllChecked(false);
      this.onItemChecked(item, true);
    }
    if (this._config.listeners && this._config.listeners.onRowClick)
      this._config.listeners.onRowClick(item);

  }

}

